import { combineReducers, createStore, applyMiddleware } from 'redux';
import promiseMiddleware from './libs/promiseMiddleware';
// import logger from 'redux-logger';
import thunk from 'redux-thunk';
import * as reducers from './reducers/';

const reducer = combineReducers({
  ...reducers,
});

const createStoreWithMiddleware = applyMiddleware(promiseMiddleware, thunk)(createStore);
const store = createStoreWithMiddleware(reducer);

export default store;



// WEBPACK FOOTER //
// ./src/store.js